import store from '@/store'
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import { appRouteNames } from '@/router'

const authorizeAuthenticated = (
    _to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
): void => {
    if (store.getters['auth/oidcIsAuthenticated']) {
        next(`/${appRouteNames.SETTINGS}`)
        return
    } else {
        next(`/${appRouteNames.WELCOME}`)
    }
}

export default authorizeAuthenticated
